import { onScopeDispose, ref } from "vue";
import { watch as watchLive } from "@/components/toLoad/live";
import { apiUser } from "@/components/toLoad/api";
import { setSnackbar } from "@/stores/ui";

function fullName(lastName, firstName) {
  return `${(lastName || "").toUpperCase()} ${firstName || ""}`.trim();
}

export function useCompanyDirectory() {
  const clients = ref([]);
  const companies = ref([]);
  const members = ref([]);
  const projects = ref([]);
  let unsubs = [];

  function stop() {
    unsubs.forEach((unsub) => unsub && unsub());
    unsubs = [];
  }

  function reset() {
    clients.value = [];
    companies.value = [];
    members.value = [];
    projects.value = [];
  }

  async function loadMembers(companyId) {
    try {
      const res = await apiUser({ method: "get", url: `/companies/${companyId}/members` });
      members.value = (res.data.documents || []).map((member) => ({
        name: fullName(member.user?.lastName, member.user?.firstName),
        id: member.id,
        avatar: member.user?.avatar,
        denom: "utilisateur",
      }));
    } catch {
      setSnackbar({ text: "Impossible de charger les participants", color: "error" });
    }
  }

  function start(companyId) {
    if (!companyId) return;
    stop();
    reset();

    unsubs = [
      watchLive(companyId, "customers", (res) => {
        clients.value = res.docs.map((document) => {
          const data = document.data();
          return {
            ...data,
            name: fullName(data.lastName, data.firstName),
            content: data.nClient,
            id: document.id,
            avatar: data.avatar,
            denom: "client",
          };
        });
      }),
      watchLive(companyId, "companies", (res) => {
        companies.value = res.docs.map((document) => {
          const data = document.data();
          return {
            ...data,
            name: data.name,
            content: data.nCompany,
            id: document.id,
            avatar: data.avatar,
            denom: "entreprise",
          };
        });
      }),
      watchLive(companyId, "projects", (res) => {
        projects.value = res.docs.map((document) => ({
          name: document.data().title,
          id: document.id,
          avatar: document.data().avatar,
        }));
      }),
    ];

    return loadMembers(companyId);
  }

  onScopeDispose(stop);

  return { clients, companies, members, projects, start, stop };
}
